import React from 'react';
import BatchImportForm from '@/components/shared/BatchImportForm';
import UICollapsibleSection from '@/components/shared/UICollapsibleSection';
import './PropertiesBatchImport.scss';

const baseClass = 'PropertiesBatchImport';

interface PropertiesBatchImportProps {
  collapsed?: boolean;
  onToggleCollapse?: () => void;
  className?: string;
}

const PropertiesBatchImport: React.FC<PropertiesBatchImportProps> = ({
  collapsed,
  onToggleCollapse,
  className = '',
}) => {
  const renderContent = () => (
    <div className={`${baseClass}__content`}>
        <BatchImportForm />
    </div>
  );

  return (
    <UICollapsibleSection
      title="Properties batch import"
      collapsible={true}
      collapsed={collapsed}
      onToggleCollapse={onToggleCollapse}
      className={`${baseClass} ${className}`.trim()}
    >
      {renderContent()}
    </UICollapsibleSection>
  );
};

export default PropertiesBatchImport;
